<template>
  <div class="repws">
    <div class="main">
      <div class="top">
        <img src="../assets/login/logo.png" alt="" />
        <p>威诺检测</p>
      </div>
      <div class="center">
        <div class="box">
          <div class="box_header">
            <p class="box_title">重置密码</p>
            <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-position="left"
              label-width="100px"
            >
              <el-form-item label="密码" prop="password">
                <el-input
                  v-model="form.password"
                  placeholder="请输入密码"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="newpassword">
                <el-input
                  v-model="form.newpassword"
                  placeholder="请确认密码"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone">
                <el-input
                  v-model="form.phone"
                  placeholder="请确认手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="code">
                <div class="input_code">
                  <el-input
                    v-model="form.code"
                    placeholder="请输入验证码"
                  ></el-input>
                  <div v-if="imgurl" @click="_httpGetCode(csrf)">
                    <img
                      style="height: 40px; width: 112px"
                      :src="imgurl"
                      alt=""
                    />
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="短信验证码" prop="phonecode">
                <div class="input_code">
                  <el-input
                    v-model="form.phonecode"
                    placeholder="请输入短信验证码"
                  ></el-input>
                  <el-button v-show="showCode" @click="getPhoneCode"
                    >获取验证码</el-button
                  >
                  <el-button disabled v-show="!showCode"
                    >还剩{{ auth_time }}秒</el-button
                  >
                </div>
              </el-form-item>
              <el-button style="width: 100%" type="primary" @click="submitForm"
                >确认</el-button
              >
            </el-form>
          </div>
        </div>
      </div>
      <div class="footer">
        <p>相关链接：xxxxxxx</p>
        <p>版本信息：xxxxxxx</p>
      </div>
    </div>
  </div>
</template>

<script>
import { httpGetCode, httpGetphone, httpReset } from "../utils/login";
export default {
  data() {
    //手机号格式校验
    const phoneCheck = (rule, value, callback) => {
      // let reg = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/;
      let reg = /^1[3456789]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        this.isphone = true;
        callback();
      }
    };
    //确认密码
    const confirm = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      csrf: sessionStorage.getItem("csrf"),
      showCode: true, //控制获取验证码按钮的显示隐藏
      auth_time: "",
      isphone: false, //倒计时逻辑控制
      imgurl: "",
      loading: false,
      form: {
        password: "",
        newpassword: "",
        phone: "",
        code: "",
        phonecode: "",
      },
      rules: {
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        newpassword: [{ required: true, validator: confirm, trigger: "blur" }],
        phone: [{ required: true, validator: phoneCheck, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        phonecode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          // console.log(this.form);
          let data = {
            pwd: this.form.password,
            confirm_pwd: this.form.newpassword,
            phone: this.form.phone,
            verifyCode: this.form.code,
            phoneVerifyCode: this.form.phonecode,
            csrf: this.csrf,
          };
          this._httpReset(data);
        } else {
          this.loading = false;
          return false;
        }
      });
    },
    _httpReset(data) {
      httpReset(data).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.$message.success(data.data);
          this.$router.push("/");
        } else {
          this.$message(data.msg);
        }
      });
    },
    //验证码倒计时
    getPhoneCode() {
      if (this.isphone == true) {
        this.showCode = false;
        this.auth_time = 60;
        let auth_timer = setInterval(() => {
          this.auth_time--;
          if (this.auth_time <= 0) {
            this.showCode = true;
            this.isphone = false;
            clearInterval(auth_timer);
          }
        }, 1000);
        this._httpGetphone(this.form.phone, "changePassword", this.csrf);
        this.isphone = false;
      } else {
        this.$message("请输入有效的手机号");
      }
    },
    //获取短信验证码
    _httpGetphone(phone, style, csrf) {
      httpGetphone(phone, style, csrf).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.$message.success(data.data);
        } else {
          this.$message(data.msg);
        }
      });
    },
    //获取图片验证码
    _httpGetCode(csrf) {
      httpGetCode(csrf).then((res) => {
        this.imgurl = window.URL.createObjectURL(res.data);
      });
    },
  },
  mounted() {
    this._httpGetCode(sessionStorage.getItem("csrf"));
  },
};
</script>

<style lang="scss" scoped>
.repws {
  width: 100%;
  height: 100%;
  .main {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .top {
      box-sizing: border-box;
      padding: 20px 80px;
      display: flex;
      justify-content: flex-start;
      p {
        height: 58px;
        line-height: 58px;
        font-size: 40px;
        color: #ff7f00;
        margin-left: 10px;
      }
    }
    .center {
      position: relative;
      background: url("../assets/login/bg@2x.png");
      background-size: 100% 100%;
      width: 100%;
      height: 100%;
      // height: calc(100%-98px);
      .box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 500px;
        height: 80%;
        border-radius: 10px;
        background: rgba($color: #fff, $alpha: 1);
        box-sizing: border-box;
        color: black;
        /deep/ .el-form-item__label,
        /deep/ .el-checkbox__label {
          color: black;
        }
        /deep/ .el-input {
          width: 200px;
          border-radius: 0px !important;
        }
        .box_header {
          padding: 20px 40px 0px;
          .box_title {
            font-size: 20px;
            font-family: Source Han Sans CN;
            margin-bottom: 20px;
            text-align: center;
          }
          .input_code {
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
              vertical-align: middle;
            }
          }
        }
      }
    }
    .footer {
      width: 100%;
      height: 60px;
      line-height: 60px;
      display: flex;
      justify-content: center;
      p {
        color: #141414;
        &:last-of-type {
          margin-left: 40px;
        }
      }
    }
  }
}
</style>